import PropTypes from "prop-types";

import { isNullish } from "@lib/app.helpers";
import { useBudgetCategories, useBudgetCategoryOptions } from "../api";
import { BudgetCategoryOptionItem } from "./budget-category-option.item";

import {
  EMERGENCY_BUDGET_CODE,
  HOUSING_BUDGET_CODE,
  SAVINGS_BUDGET_CODE,
} from "../constants";

import "./budget-category-option.list.scss";

export const BudgetCategoryOptionList = ({
  budgetPlan,
  onEdit,
  slideConfigs,
}) => {
  const { data: budgetCategories } = useBudgetCategories();
  const {
    taxInfo: { netIncome = 0 } = {},
    options,
    isLivingAlone,
  } = budgetPlan ?? {};

  // Use the order of the slide configs to display the budget categories
  const budgetCategoryOptionItems = slideConfigs.map((slide) => {
    const category = budgetCategories[slide.budgetCategoryCode];
    const optionSelected = options?.find(
      (option) => option.budgetCategoryOption.budgetCategoryId === category?.id,
    );
    const { data: categoryOptions } = useBudgetCategoryOptions(category?.id);
    let amount = optionSelected?.budgetCategoryOption?.amount;
    let canEdit = true;

    if (isNullish(category)) {
      return;
    }

    if (category.code === HOUSING_BUDGET_CODE) {
      amount = amount / (isLivingAlone ? 1 : 2);
    } else if (
      category.code === SAVINGS_BUDGET_CODE ||
      category.code === EMERGENCY_BUDGET_CODE
    ) {
      amount = amount * (netIncome / 12);
      canEdit = false;
    } else if (categoryOptions?.length === 1) {
      // Categories with only one option cannot be edited
      canEdit = false;
    }

    const categoryOption = {
      category,
      option: { ...optionSelected?.budgetCategoryOption, amount },
    };

    return (
      <BudgetCategoryOptionItem
        key={category.code}
        categoryOption={categoryOption}
        onEdit={() => onEdit(categoryOption)}
        canEdit={canEdit}
      />
    );
  });

  return (
    <div className="budget-category-option-list">
      {budgetCategoryOptionItems}
    </div>
  );
};

BudgetCategoryOptionList.propTypes = {
  budgetPlan: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  slideConfigs: PropTypes.array.isRequired,
};
